<template>
  <div class="banners-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${bannerId ? 'Editar' : 'Cadastrar'} Banner`">
      <button
        type="button"
        v-app-button.clear.icon-left
        v-app-back-button="{ name: 'banners.index' }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>
    <app-card>
      <banners-form
        @submit="onSubmit"
        :id="bannerId"
        :errors="errors"
        :saving="isSaving"
      ></banners-form>
    </app-card>
  </div>
</template>

<script>
import BannerService from '@/services/banner.service';
import BannersForm from '@/components/Forms/BannersForm.vue';

export default {
  name: 'banners-form-page',
  components: {
    BannersForm,
  },
  data: () => {
    return {
      bannerId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(banner) {
      this.bannerId && this.update(this.bannerId, banner);
      !this.bannerId && this.save(banner);
    },
    save(banner) {
      this.isSaving = true;
      BannerService.save(banner)
        .then(() => {
          this.toastify('Banner cadastrado com sucesso!');
          this.$router.push({ name: 'banners.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Banner.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, banner) {
      this.isSaving = true;
      BannerService.update(id, banner)
        .then(() => {
          this.toastify('Banner atualizado com sucesso!');
          this.$router.push({ name: 'banners.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Banner.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.bannerId = this.$route.params.id;
  },
};
</script>
